<template>
  <div class="row">
    <div class="small-12 medium-12 large-5 columns dados_pessoa">
      <p class="pessoa_cargo">
        {{cargoTipo}}
      </p>
      <a class="pessoa_nome">{{ nome }}</a>
      <p class="pessoa_email">
        <i class="fa fa-envelope-o"></i>{{ email }}
      </p>
      <p class="pessoa_email" v-show="emailsec.length > 0">
        <i class="fa fa-envelope-o"></i>{{ emailsec }}
      </p>
      <a :href="twitter" class="pessoa_twitter" v-show="twitter.length > 0">
        <i class="fa fa-twitter"></i>{{ twitter }}
      </a>
    </div>
    <div class="small-12 medium-12 large-7 columns orgaos_botao">
      <router-link
          to="/orgaos-e-departamentos"
          class="button ver_orgaos"
          :class="$store.state.faculdadename">
        {{ $translate("UMA_LANG_FACULDADE_ORGAOSEDEPARTAMENTOS") }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PresidenteData",
  inject:["i18n"],
  props:["cargo","nome","emailsec","email","twitter"],
  computed:{
    cargoTipo(){
      var value = this.$store.state.faculdade.tipo;
      var type = "";
      value.split(" ").map(el => {
        type = type + el.charAt(0).toUpperCase() + el.slice(1) + " "
      });
      return this.$translate("UMA_LANG_FACULDADE_PRESIDENTE")+" "+ type
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../global";

/*138-188*/

.pessoa_cargo {
  font-family: "PT Sans Italic";
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
}

.pessoa_nome {
  font-family: "Montserrat Semibold";
  color: #454648;
  font-size: 16px;
  line-height: 1.85;
  margin-bottom: 2px;
}

.pessoa_email,.pessoa_twitter {
  font-family: "PT Sans Italic";
  font-size: 16px;
  margin-top: 10px;
  color: #333333;
  margin-bottom: 7px;
}

.pessoa_twitter {
  font-family: "PT Sans Italic";
  display: flex;
  align-items: center;
}

.pessoa_twitter:hover{
  color:#000;
}

.pessoa_email i {
  margin-right: 8px;
}

.pessoa_twitter i {
  font-size: 20px;
  margin-right: 8px;
}

.dados_pessoa {
  padding-left: 27px;
  padding-right: 19px;
  padding-top: 40px;
}

/*172*/
.ver_orgaos {
  font-family: 'Montserrat Bold';
  font-size: 14px;
  margin-left: 0;
  letter-spacing: 0px;
  padding: 24px 50px;
  margin-top: 50px;
  float: right;
  color: white;
  margin-bottom: 110px;
  text-transform: uppercase;
}

@media only screen and (max-width: 1439px) {

  /*1026-1043*/
  .dados_pessoa {
    padding-left: 18px;
    padding-top: 18px;
  }

  .pessoa_email {
    font-size: 14px;
  }

  .pessoa_cargo {
    font-size: 14px;
  }

  .pessoa_nome {
    line-height: 1.35;
  }

  /*1043*/
  .ver_orgaos {
    margin-top: 25px;
    margin-bottom: 80px;
  }

}

/*1083*/
@media (min-width : 768px)
and (max-width : 1024px) {

  /*1148*/
  .ver_orgaos {
    font-size: 15px;
    padding-top: 21px;
    padding-bottom: 21px;
    display: block;
    margin: 20px auto 80px;
    width: 100%;
    float: none;
  }

  /*1162-1167*/
  .columns {
    padding-right: 0!important;
    padding-left: 0!important;
  }

  /*1316*/
  .dados_pessoa {
    margin-left: 8px;
  }

}


@media (max-width: 839px) {

  .dados_pessoa {
    padding-top: 0px;
  }

  .row .columns:nth-of-type(2) {
    display: flex;
    justify-content: center;
  }

  .ver_orgaos {
    margin-top: 10px;
    font-size: 13px;
    letter-spacing: 0;
    position: relative;
    padding: 20px 50px;
    margin-bottom: 40px;
  }

}

@media (max-width: 767px) {

  /*1503*/
  .columns {
    padding-right: 0!important;
    padding-left: 0!important;
  }

  /*1533-1542*/
  .pessoa_cargo {
    margin-bottom: 0;
  }

  .pessoa_email {
    font-size: 14px;
    margin-top: 0;
  }

  .pessoa_nome {
    font-size: 14px;
  }

}

.ver_orgaos.artesehumanidades{
  background-color: $ahc1;
}

a.ver_orgaos.artesehumanidades:hover {
  background-color: $ahc2 !important;
}

.ver_orgaos.cienciasexatasedaengenharia{
  background-color: $ceec1;
}

a.ver_orgaos.cienciasexatasedaengenharia:hover {
  background-color: $ceec2 !important;
}

.ver_orgaos.cienciassociais{
  background-color: $ccc1;
}

a.ver_orgaos.cienciassociais:hover {
  background-color: $ccc2 !important;
}

.ver_orgaos.cienciasdavida{
  background-color: $cvc1;
}

a.ver_orgaos.cienciasdavida:hover {
  background-color: $cvc2 !important;
}

.ver_orgaos.escolasuperiordetecnologiasegestao{
  background-color: $estgc1;
}

a.ver_orgaos.escolasuperiordetecnologiasegestao:hover {
  background-color: $estgc2 !important;
}

.ver_orgaos.escolasuperiordesaude{
  background-color: $essc1;
}

a.ver_orgaos.escolasuperiordesaude:hover {
  background-color: $essc2 !important;
}
</style>